import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapActions } from "vuex";
import { tabulation, customPaging, gmToolNewPage } from "@/mixins/index";
import { orderDisplayList, orderDisplayList_currency, productOrderAll } from "@/api/dataAll/orderDisplay";
import addLinks from "./components/addLinks";
import clipboard from "@/utils/clipboard";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "productOrderDetails",
  components: {
    addLinks: addLinks
  },
  mixins: [tabulation, customPaging, gmToolNewPage],
  data: function data() {
    return {
      value1: [],
      value2: [],
      total: 0,
      pagrSize: 10,
      searchData: {
        page_size: 10,
        page: 1,
        payChannel: "",
        order_id: "",
        server_id: "",
        user_id: ""
      },
      tableData: [],
      intReq: [],
      isServer: false,
      exportLoading: false,
      serverLists: [],
      deduplicationList: [{
        label: this.$t('yes'),
        value: 1
      }]
    };
  },
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';
    this.getsearchDate();
    this.getServerLists();
    this.isServer = this.rawData.game_mark.indexOf("royalpirates") > -1 || this.rawData.game_mark.indexOf("yjfm") > -1 ? true : false;
  },
  activated: function activated() {
    var paramsData = this.$route.params;
    this.searchData.user_id = paramsData ? paramsData.user_id : "";

    if (this.searchData.user_id) {
      if (paramsData.type == "D") {
        this.value2 = [paramsData.date, paramsData.date];
      } else if (paramsData.type == "W") {
        var dateArr = paramsData.date.split("/");
        this.value2 = this.weeks(dateArr[1])[dateArr[0].substring(1, 2) - 1];
      } else if (paramsData.type == "M") {
        this.value2 = this.fld(paramsData.date);
      } else if (paramsData.type == "Y") {
        this.value2 = this.getYearFirstLastDay(paramsData.date);
      } // this.searchClick(1);

    }
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  methods: {
    selectAll: function selectAll() {
      var _this = this;

      this.searchData.server_id = [];

      if (this.checked) {
        this.serverListYJ.map(function (item) {
          _this.searchData.server_id.push(item.serverID);
        });
      } else {
        this.searchData.server_id = [];
      }
    },
    selecRotAll: function selecRotAll() {
      var _this2 = this;

      this.searchData.server_id = [];

      if (this.checked) {
        this.serverLists.map(function (item) {
          _this2.searchData.server_id.push(item.serverID);
        });
      } else {
        this.searchData.server_id = [];
      }
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.searchClick(1);
    },
    //请求服务器列表  用于指定海盗和御剑请求
    getServerLists: function getServerLists() {
      this.RollSuit = false;
      this.serverLists = [];
      this.searchData.server_id = null;
      this.searchData.is_prod = "";
      var game = this.rawData.game_mark;

      if (game.indexOf(this.royalpirates) > -1) {
        this.RollSuit = this.severlist.length ? true : false;
      } else if (game.indexOf("yjfm") > -1) {
        this.RollSuit = true; // yjServerList().then((res) => {
        //   if (res.code == 200) {
        //     res.data.map((i) => {
        //       i.openTime = this.$times.dateTimeToTimeStamp(this.$times.formDate(i.created_at.replaceAll(".000000", "")));
        //       i.serverName = i.name;
        //       i.serverID = i.id;
        //     });
        //     this.serverLists = res.data;
        //   }
        // });
      }
    },
    getServerList: function getServerList() {
      var _this3 = this;

      var env_id = this.propsData ? this.propsData.env_id : this.searchData.env_id;
      yjServerList({
        server_channel: this.server_channel,
        show_test: this.show_test,
        env_id: env_id
      }).then(function (res) {
        if (res.code == 200) {
          _this3.serverListYJ = res.data;
        }
      });
    },
    severlistChange: function severlistChange(e) {
      var _this4 = this;

      this.serverLists = [];
      this.searchData.server_id = "";

      if (e) {
        hdServerList({
          is_prod: this.searchData.is_prod
        }).then(function (res) {
          if (res.status == 200) {
            _this4.serverLists = res.data;
          }
        });
      }
    },
    // 获取指定月份 第一天和有效的最后一天
    fld: function fld(date) {
      var nowDate = this.getNowDate("YY-MM-DD");
      var nowDatearr = nowDate.split("-");
      var arr = date.split("-");
      var year = Number(arr[0]);
      var month = Number(arr[1]);
      var firstDay = new Date(year, month - 1, 1); //这个月的第一天

      var currentMonth = firstDay.getMonth(); //取得月份数

      var lastDay = new Date(firstDay.getFullYear(), currentMonth + 1, 0); //是0而不是-1

      return [this.$times.timestampToTime(firstDay / 1000, "YY-MM-DD"), arr[0] == nowDatearr[0] && arr[1] == nowDatearr[1] ? nowDate : this.$times.timestampToTime(lastDay / 1000, "YY-MM-DD")];
    },
    //
    getMonthWeek: function getMonthWeek(theDate) {
      var currentDay = new Date(theDate); // 获取该日期所在周的周六，如2019.5月的周六有4号、11号、18号、25号、31号

      var theSaturday = currentDay.getDate() + (6 - currentDay.getDay());
      return Math.ceil(theSaturday / 7);
    },
    // 年份计算
    getYearFirstLastDay: function getYearFirstLastDay(Y) {
      var nowDate = this.getNowDate("YY-MM-DD");
      var nowDatearr = nowDate.split("-");
      return [Y + "-01-01", nowDatearr[0] == Y ? nowDate : lastDay + "-12-31"];
    },
    weeks: function weeks(now_month) {
      var week_array = [];
      var today = new Date(Date.parse(now_month));
      var year = today.getFullYear();
      var month = today.getMonth();
      var i = 0;
      var start = new Date(year, month, 1); // 得到当月第一天

      var end = new Date(year, month + 1, 0); // 得到当月最后一天
      // 循环每周最后天叠设置为第一天，直到最后一天小于当月的最后一天

      while (start <= end) {
        var monday = new Date(start.getTime());
        var sunday = new Date(start.getTime());
        monday.setDate(monday.getDate() + 1 - monday.getDay());
        sunday.setDate(sunday.getDate() + 7 - sunday.getDay());
        week_array.push([this.$times.timestampToTime(monday / 1000, "YY-MM-DD"), this.$times.timestampToTime(sunday / 1000, "YY-MM-DD")]);
        start = sunday;
      }

      week_array[0][0] = this.$times.timestampToTime(new Date(year, month, 1) / 1000, "YY-MM-DD");
      week_array[week_array.length - 1][1] = this.$times.timestampToTime(new Date(year, month + 1, 0) / 1000, "YY-MM-DD");
      return week_array;
    },
    // 获取当日日期
    getNowDate: function getNowDate(type) {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();

      if (type == "YY-MM-DD") {
        var date = year + "-" + month + "-" + date;
      }

      return date;
    },
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.value2 = [date, date];
    },
    searchClick: function searchClick(e) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var searchData, reqFn;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // if(this.currencyClose && !this.searchData.currency_info){
                //   this.$message.error('请选择货币类型')
                //   return
                // }
                if (_this5.value2 && Array.isArray(_this5.value2) && _this5.value2.length > 0) {
                  _this5.searchData.starttime = _this5.value2[0];
                  _this5.searchData.endtime = _this5.value2[1];
                } else {
                  _this5.searchData.starttime = "";
                  _this5.searchData.endtime = "";
                }

                _this5.searchData.kind = 1;

                if (_this5.value1 && Array.isArray(_this5.value1) && _this5.value1.length > 0) {
                  _this5.searchData.activation_time = _this5.value1[0];
                  _this5.searchData.activation_endtime = _this5.value1[1];
                } else {
                  _this5.searchData.activation_time = "";
                  _this5.searchData.activation_endtime = "";
                }

                _this5.reqLoading = true;
                _this5.searchData.page = e;
                searchData = JSON.parse(JSON.stringify(_this5.searchData));
                searchData.ad_placement = searchData.ad_placement == "valuets" ? [""] : searchData.ad_placement; // let reqFn = this.currencyClose ? orderDisplayList_currency : orderDisplayList;

                reqFn = productOrderAll;
                _context.next = 10;
                return _this5.getexchangeRate();

              case 10:
                reqFn(_objectSpread(_objectSpread({}, _this5.searchData), _this5.defaultData())).then(function (res) {
                  if (res.status == 200) {
                    _this5.currentPage = 1;
                    res.data.data.map(function (item) {
                      item.timestamp = _this5.$times.timestampToTime(item.timestamp);
                      item.amountNew = _this5.isyjfmvnd() ? item.amount.toFixed(2) : _this5.$utils.conversion(item.amount).toFixed(2);
                      item.amountNewexchange = _this5.isyjfmvnd() ? (item.amount * _this5.exchangeRate).toFixed(2) : _this5.$utils.conversion(item.amount * _this5.exchangeRate).toFixed(2);
                      item.currency_amount = _this5.isyjfmvnd() ? _this5.$utils.conversion(item.currency_amount).toFixed(2) : item.currency_amount; // 充值时间

                      item.new_dateOne = item.new_date ? item.new_date.substring(0, 10) : '/';
                      item.new_dateTow = item.new_date ? item.new_date.substring(10, 20) : '/'; // 注册时间

                      item.register_timeOne = item.register_time ? item.register_time.substring(0, 10) : '/';
                      item.register_timeTow = item.register_time ? item.register_time.substring(10, 20) : '/'; // 激活时间

                      item.activity_timeOne = item.activity_time ? item.activity_time.substring(0, 10) : '/';
                      item.activity_timeTow = item.activity_time ? item.activity_time.substring(10, 20) : '/';
                    });
                    var list = ["game", "platform", "channel", "pkg", "ad_channel", "ad_placement"];
                    _this5.tableData = res.data.data.length ? _this5.$utils.dataConversion(res.data.data, list) : [];
                    _this5.total = res.data.total ? res.data.total - 0 : 0; // this.tableCopyTableList = JSON.parse(JSON.stringify(this.$utils.dataConversion(res.data, list)))
                    // this.tableData = this.currentChangePage(this.pageSize, this.currentPage)

                    _this5.$nextTick(function () {
                      _this5.getTableRight();
                    });
                  }
                }).finally(function () {
                  _this5.reqLoading = false;
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleSource: function handleSource(id, num) {
      var _this6 = this;

      this.$nextTick(function () {
        _this6.$refs.addWayConfig.init(id, num);
      });
    },
    handleClipboard: function handleClipboard(text, event) {
      clipboard(text, event);
    },
    // handleCurrentChange(val) {
    //   this.searchData.page = val;
    //   this.searchClick();
    // },
    handleDelete: function handleDelete(id) {
      var _this7 = this;

      this.$confirm(this.$t('confirmDeleteLink'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                deleLinksList({
                  id: id
                }).then(function (res) {
                  _this7.searchClick();
                });

                _this7.$message({
                  type: "success",
                  message: _this7.$t('deleteSuccessExclamation')
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    mereList: function mereList() {
      var _this8 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(resolve, reject) {
          var that, list;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this8.exportLoading = true;
                  that = _this8;
                  list = [];
                  _context3.next = 5;
                  return productOrderAll(_objectSpread(_objectSpread(_objectSpread({}, that.searchData), that.defaultData()), {}, {
                    page: 1,
                    page_size: -1
                  })).then(function (res) {
                    if (res.status == 200) {
                      res.data.data.map(function (i) {
                        i.request = i.params ? i.params.request ? JSON.stringify(i.params.request) : '' : '';
                        i.response = i.params ? i.params.response ? JSON.stringify(i.params.response) : '' : '';
                        i.timestamp = that.$times.timestampToTime(i.timestamp);
                      });
                      res.data.data.map(function (item) {
                        item.timestamp = that.$times.timestampToTime(item.timestamp);
                        item.amountNew = that.$utils.conversion(item.amount).toFixed(2);
                        item.currency_amount = that.isyjfmvnd() ? that.$utils.conversion(item.currency_amount).toFixed(2) : item.currency_amount; // 充值时间

                        item.new_dateOne = item.new_date ? item.new_date.substring(0, 10) : '/';
                        item.new_dateTow = item.new_date ? item.new_date.substring(10, 20) : '/'; // 注册时间

                        item.register_timeOne = item.register_time ? item.register_time.substring(0, 10) : '/';
                        item.register_timeTow = item.register_time ? item.register_time.substring(10, 20) : '/'; // 激活时间

                        item.activity_timeOne = item.activity_time ? item.activity_time.substring(0, 10) : '/';
                        item.activity_timeTow = item.activity_time ? item.activity_time.substring(10, 20) : '/';
                      });
                      var lists = ["game", "platform", "channel", "pkg", "ad_channel", "ad_placement"];
                      list = res.data.data.length ? _this8.$utils.dataConversion(res.data.data, lists) : [];
                      resolve(list);
                    }
                  }).finally(function () {});

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    exportdata: function exportdata() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var list, columns, exchangeUSD, exchangeVND, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this9.mereList();

              case 2:
                list = _context4.sent;
                _this9.exportLoading = false; // let list = this.tableCopyTableList;

                columns = [{
                  label: _this9.$t('serverId'),
                  prop: "server_id"
                }, {
                  label: _this9.$t('game'),
                  prop: "game_reveal"
                }, {
                  label: _this9.$t('platform'),
                  prop: "platform_reveal"
                }, {
                  label: _this9.$t('channel'),
                  prop: "channel_reveal"
                }, {
                  label: _this9.$t('adChannel'),
                  prop: "ad_channel_reveal"
                }, {
                  label: _this9.$t('adPlacement'),
                  prop: "ad_placement_reveal"
                }, {
                  label: _this9.$t('pkg'),
                  prop: "pkg_reveal"
                }, {
                  label: _this9.$t('userId'),
                  prop: "user_id"
                }, {
                  label: _this9.$t('roleId'),
                  prop: "role_id"
                }, {
                  label: _this9.$t('deviceId'),
                  prop: "device_id"
                }, {
                  label: _this9.$t('orderId'),
                  prop: "order_id"
                }, {
                  label: _this9.$t('amount'),
                  prop: "amount"
                }, {
                  label: _this9.$t('rechargeAmountNew'),
                  prop: "amountNew"
                }, {
                  label: _this9.$t('productName'),
                  prop: "product_name"
                }, {
                  label: _this9.$t('productId'),
                  prop: "product_id"
                }, {
                  label: _this9.$t('payChannelLabel'),
                  prop: "pay_channel"
                }, {
                  label: _this9.$t('channelOrderId'),
                  prop: "pay_channel_order_id"
                }, {
                  label: _this9.$t('rechargeTime'),
                  prop: "new_dateOne"
                }, {
                  label: _this9.$t('timePoint'),
                  prop: "new_dateTow"
                }, {
                  label: _this9.$t('deviceActiveTime'),
                  prop: "activity_timeOne"
                }, {
                  label: _this9.$t('timePoint'),
                  prop: "activity_timeTow"
                }, {
                  label: _this9.$t('registerTime'),
                  prop: "register_timeOne"
                }, {
                  label: _this9.$t('timePoint'),
                  prop: "register_timeTow"
                }, {
                  label: _this9.$t('ip'),
                  prop: "ip"
                }];
                exchangeUSD = [{
                  label: _this9.$t('currencyAmountUsd'),
                  prop: "currency_amount"
                }];
                exchangeVND = [{
                  label: _this9.$t('currencyAmountVnd'),
                  prop: "currency_amount"
                }];

                if (_this9.queryCurrency == "USD") {
                  exchangeVND.unshift(12, 0);
                  Array.prototype.splice.apply(columns, exchangeVND);
                }

                if (_this9.queryCurrency == "VND") {
                  exchangeUSD.unshift(12, 0);
                  Array.prototype.splice.apply(columns, exchangeUSD);
                } // if(this.searchData.pay_channel){
                //   columns.splice(13,0,{
                //     label: "支付渠道",
                //     prop: "pay_channel",
                //   })
                // }


                data = list;

                _this9.$export.excel({
                  columns: columns,
                  data: data,
                  title: _this9.$route.meta.title
                });

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};